import { render } from "./Com_Content.vue?vue&type=template&id=74833b64"
import script from "./Com_Content.vue?vue&type=script&lang=js"
export * from "./Com_Content.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__